<!-- Small/Medium viewport -->
<div class="d-block d-lg-none mb-4">
    <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center subheader pt-1 pb-1">
        <div class="col-12 text-truncate">
            <strong>{{request.jobName}}</strong>
        </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
        <div class="col-3 col-md-2 text-truncate">
            <span translate>Request.ReviewSend.Type</span>
        </div>
        <div class="col-9 col-md-10 text-truncate">
            <span translate="Type.{{requestType}}"></span>
        </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
            <div class="col-3 col-md-2 text-truncate">
                <span translate>Request.ReviewSend.Credits</span>
            </div>
            <div class="col-9 col-md-10 text-truncate">
                <span> <app-request-credit-summary [requestGuid]="request.id"></app-request-credit-summary>{{ request.id }}</span>
            </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1" *ngIf="request.workgroup">
        <div class="col-3 col-md-2 text-truncate">
            <span translate>Request.ReviewSend.Workgroup</span>
        </div>
        <div class="col-9 col-md-10 text-truncate">
            <span>{{request.workgroupName}}</span>
        </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1" *ngIf="request.workgroup && request.clearancelevel">
        <div class="col-3 col-md-2 text-truncate">
            <span translate>Request.ReviewSend.Clearence</span>
        </div>
        <div class="col-9 col-md-10 text-truncate">
            <span>{{request.clearancelevel}}</span>
        </div>
        </li>
    </ul>
</div>

<!-- Large viewport -->
<ul class="d-none d-lg-block list-group pt-4 pe-0 pb-0 ps-0">
    <li class="list-group-item subheader d-block pt-1 pe-0 pb-1 ps-2 bg-light">
        <div class="row w-100 d-flex p-0 align-items-center ">
            <div class="col-4 firstcol text-truncate" translate>Request.ReviewSend.RequestTitle</div>
            <div class="col-2 text-truncate" translate>Request.ReviewSend.RequestType</div>
            <div class="col-1 text-truncate" [ngClass]="{'col-4': !request.workgroup || request.workgroup === '' }" translate>Request.Status.Credits</div>
            <div class="col-2 text-truncate" *ngIf="request.workgroup" translate>Request.ReviewSend.Workgroup</div>
            <div class="col-1 text-truncate" *ngIf="request.workgroup && MaxClearnaceIsNotOne()" translate>Request.ReviewSend.Clearence</div>
            <div class="col-2 text-truncate" translate>Request.ReviewSend.RequestId</div>
        </div>
    </li>
    <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2">
        <app-reviewandsendsummaryitem [request]="request" [requestType]="requestType"></app-reviewandsendsummaryitem>
    </li>
</ul>